/* import 'react-app-polyfill/ie11';
import 'babel-polyfill';
import 'url-search-params-polyfill';

import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/is-nan';
import 'core-js/es6/string';
import 'babel-polyfill'
*/
import React from 'react';
import ReactDOM from 'react-dom';
import Guppyi from './Guppyi';
import GuppyiI18n from './i18n/GuppyiI18n';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap'

import './css/Guppyi.css';
import './css/bootstrap-3-icons.css';


const __paramI18n = new URLSearchParams(window.location.search).get('i18n');
const __currentUrl = window.location.href;

if(__paramI18n === 'true' || __currentUrl.includes("i18n")) {
  ReactDOM.render(<GuppyiI18n/>, document.getElementById('root'));
} else {
  ReactDOM.render(<Guppyi/>, document.getElementById('root'));
}
